import { FC, useEffect, useState } from 'react';
import { NodeObject } from 'react-force-graph-2d';
import { IconButton, List, ListItemButton, Stack } from '@mui/material';
import { Icon } from '@iconify/react';
import { FilterInput, FuseResult } from '../../DataDrawer/FilterInput';
// eslint-disable-next-line import/no-cycle
import { NodeType } from '../NodeContextMenu';

interface NodesListProps {
  nodes: NodeObject[];
  chosenNode: (node: string, type: NodeType) => void;
  onQueryChange: (q: string) => void;
}

export const NodesList: FC<NodesListProps> = ({
  nodes,
  chosenNode,
  onQueryChange,
}) => {
  const [filteredNodes, setFilteredNodes] =
    useState<FuseResult<NodeObject>[]>();

  const areNodesNotEmpty = nodes && nodes.length > 0;

  const [q, setQ] = useState<string>('');

  useEffect(() => {
    onQueryChange(q);
  }, [q, onQueryChange]);

  const AddManualNode = () => (
    <Stack alignItems={'center'}>
      <IconButton
        sx={{ width: 65, height: 65, fontSize: 50 }}
        onClick={() => {
          chosenNode(q, 'manual');
        }}
      >
        <Icon icon="carbon:add-filled" color={'#c5cae9'} />
      </IconButton>
    </Stack>
  );

  return (
    <Stack
      sx={{
        px: 2,
        minWidth: 500,
        height:
          areNodesNotEmpty && (!filteredNodes || filteredNodes?.length > 0)
            ? 500
            : '100%',
        pb: areNodesNotEmpty ? null : 2,
      }}
    >
      <FilterInput
        data={nodes}
        placeholder={'Manual node'}
        onEnterKeyDown={() => {
          if (q && q.length > 0) {
            chosenNode(q, 'manual');
          }
        }}
        filterCallback={(result) => {
          setFilteredNodes(result);
        }}
        onType={(q) => {
          setQ(q);
        }}
      />
      {areNodesNotEmpty ? (
        <List>
          {filteredNodes && filteredNodes.length === 0 && <AddManualNode />}
          <>
            {filteredNodes
              ? filteredNodes.map((node) => (
                  <ListItemButton
                    key={`filtered-node-${node.item.id}`}
                    onClick={() => {
                      chosenNode(node.item.id as string, 'existing');
                    }}
                  >
                    {node.item.id}
                  </ListItemButton>
                ))
              : nodes.map((node) => (
                  <ListItemButton
                    key={`filtered-node-${node.id}`}
                    onClick={() => {
                      chosenNode(node.id as string, 'existing');
                    }}
                  >
                    {node.id}
                  </ListItemButton>
                ))}
          </>
        </List>
      ) : (
        filteredNodes && filteredNodes.length === 0 && <AddManualNode />
      )}
    </Stack>
  );
};
